import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

const ProtectedAdminRoute = () => {
  // Check if user is admin from local token storage
  const token = localStorage.getItem('token');
  let isAdmin = false;

  if (token) {
    const decodedToken = jwtDecode(token);
    isAdmin = decodedToken.role === 'admin';
  } else {
    return <Navigate to="/" />;
  }

  return isAdmin ? <Outlet /> : <Navigate to="/platform" />;
};

export { ProtectedRoute, ProtectedAdminRoute };